/* eslint-disable no-unused-vars */
"use client";
import React, { useState, useCallback, useMemo, useEffect } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSharedData } from "bossjob-remote/dist/hooks";

import Empty from "../../Empty";
import CardMobile from "../../Card/mobile/index.mobile";
import { jobCountSourceTracker } from "components/ReportTracker/util";
import { reportTrackerJobCounts } from "components/ReportTracker/JobCountTracker";
import { getCountryId, getCountryKey } from "helpers/country";

import styles from "../../../style/index.mobile.module.scss";
import { getCookie } from "helpers/cookies";

const MainMobile = (props: any) => {
  const {
    jobs = [],
    page,
    totalPages,
    searchParams,
    job_search_empty,
    config,
    dictionary,
    lang
  } = props;
  const [jobList, setJobList] = useState(jobs);

  useEffect(() => {
    setJobList(() => [...jobs]);
  }, [jobs]);

  if (jobs && jobs.length) {
    return (
      <div className={styles.mobileContainer}>
        {jobList.map((job) => {
          return (
            <div className={styles.jobContainer} key={job?.job_id}>
              <CardMobile job={job} lang={lang} />
            </div>
          );
        })}

        <div className={styles.loadMore}>
          <NoMore lang={lang} config={config} />
        </div>
      </div>
    );
  }

  return (
    <Empty
      job_search_empty={job_search_empty}
      searchParams={searchParams}
      config={config}
      dictionary={dictionary}
    />
  );
};

const NoMore = ({ config, lang }) => {
  const { more_filter_text } = config;
  const isLogin = getCookie("sessionid") ? true : false;
  const countryId = getCountryId();
  const countryKey = getCountryKey();

  const handleClick = () => {
    let url = "";
    if (isLogin) {
      switch (countryKey) {
        case "ph":
          url = "https://bossjob.go.link/?adj_t=1lsc864b&adj_engagement_type=fallback_click";
          break;
        case "sg":
          url = "https://bossjob.go.link/?adj_t=1l2dbf4i&adj_engagement_type=fallback_click";
          break;
        case "jp":
          url = "https://bossjob.go.link/?adj_t=1lah3ncz&adj_engagement_type=fallback_click";
          break;
        default:
          url = `https://app.adjust.com/1j5xceej`;
          break;
      }
    } else {
      url = `/${lang}/get-started`;
    }
    window?.gtag?.("event", "More_Jobs_Download", {
      country_id: countryId
    });
    window.location.href = url;
  };

  useEffect(() => {
    window?.gtag?.("event", "More_Jobs_Exposure", {
      country_id: countryId
    });
  }, []);
  return (
    <div className={styles.viewMore}>
      <div className={styles.viewMoreBtn} onClick={handleClick}>
        {more_filter_text}
      </div>
    </div>
  );
};

export default MainMobile;
